import React from 'react'
import { SxProps, Theme } from '@mui/material'

import MUIDataGrid from './AbstractDataGrid/DataGridMUI'

export interface AbstractAuditLogDataGridProps {
  getRowId
  columns
  rows
  tableHeight?: string
  rowHeight?: number
  sx?: SxProps<Theme>
  pagination?: boolean
  rowCount?: number
  page?: number
  pageSize?: number
  onPageChange?: (newPage: number) => void
  loading?: boolean
}

export default function AbstractAuditLogDataGrid(
  props: AbstractAuditLogDataGridProps
) {
  const {
    getRowId,
    columns,
    rows,
    tableHeight,
    rowHeight,
    sx,
    rowCount,
    pagination,
    page,
    pageSize,
    onPageChange,
    loading
  } = props
  return (
    <MUIDataGrid
      loading={loading}
      getRowId={getRowId}
      columns={columns}
      rows={rows}
      tableHeight={tableHeight ? tableHeight : '300px'}
      rowHeight={rowHeight ? rowHeight : 52}
      hideFooter={pagination ? false : true}
      disableColumnFilter
      disableColumnMenu
      disableSelectionOnClick
      pagination
      rowCount={rowCount}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
      sx={{
        '& .MuiDataGrid-iconSeparator': {
          visibility: 'hidden'
        },
        '& .MuiDataGrid-footerContainer': {
          border: '0'
        },
        '& .MuiDataGrid-cellContent': {
          fontSize: '12px',
          whiteSpace: 'normal !important',
          wordWrap: 'break-word !important'
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          fontSize: '12px',
          fontWeight: '500'
        },
        '& .MuiDataGrid-cell': {
          border: '0'
        },
        '& .MuiDataGrid-columnHeaders': {
          border: '1',
          borderColor: 'black'
        },
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
          outline: 'none'
        },
        mx: '-10px',
        ...sx
      }}
    />
  )
}
